import React, {useEffect, useState} from 'react';
import {DropDownList, DropDownListChangeEvent} from "@progress/kendo-react-dropdowns";
import {SelectModel} from "../../../../../../../app/types/SelectModel";
import {isAxiosError} from "axios";
import {toast} from "react-toastify";
import {useAppSelector} from "../../../../../../../app/store";
import {selectCurrentUser} from "../../../../../../../features/authentication/authenticationSliceSelectors";
import {getUserRole} from "../../../../../../../helpers/user";
import {UserRole} from "../../../../../../../app/enums/UserRole";
import {ResponseResultCode} from "../../../../../../../app/enums/ResponseResultCode";
import { useDataHelperApi } from '../../../../../../../app/api/dataHelper';
import { spawn } from 'child_process';

type EditTransportVehicleForGreenRouterSelectorProps = {
    disabled: boolean;
    isLoadingPrefilledValue: boolean;
    vehicleForGreenRouter: string | null;
    onChange: (ev: DropDownListChangeEvent) => void;
}

const EditTransportVehicleForGreenRouterSelector: React.FC<EditTransportVehicleForGreenRouterSelectorProps> = ({
                                                                                           vehicleForGreenRouter,
                                                                                           onChange,
                                                                                           disabled,
                                                                                           isLoadingPrefilledValue
                                                                                       }) => {
    const user = useAppSelector(selectCurrentUser);

    return (
        // <DropDownList data={data}
        //               className={'edit-transport-vehicle-value'}
        //               disabled={disabled || isLoading || !user}
        //               loading={isLoading || !user || isLoadingPrefilledValue}
        //               textField="text"
        //               dataItemKey="value"
        //               value={vehicleForGreenRouter !== null ? data.find(e => e.value === vehicleForGreenRouter) 
        //                 : data.find(e => e.value === "")}
        //               onChange={onChange}
        // />

        vehicleForGreenRouter ? <span>{vehicleForGreenRouter}</span> : <span>No found</span>
    );
};

export default EditTransportVehicleForGreenRouterSelector;